/* Yake Online — 5 Eki 2026: karttaki stoksuz bedenden (#haber-ver) gelince "Gelince haber ver" panelini aç */
(function () {
  if (location.hash !== '#haber-ver') return;
  var tries = 0;
  (function open() {
    var btn = document.querySelector('.product-form__alert[aria-controls^="BackInStockDrawer"]');
    var submit = document.querySelector('.product-form__submit[data-back-in-stock]');
    if (btn && submit && submit.disabled && btn.offsetParent !== null) {
      btn.scrollIntoView({ block: 'center' });
      btn.click();
      return;
    }
    if (++tries < 40) setTimeout(open, 250);
  })();
})();

/* 5 Eki 2026 (173): liste kartında üstüne gelince görseller arası geçiş yavaş.
   Kart karuseli (theme.js SecondaryMedia → Flickity) varsayılanı ~0,33 sn; süre tema ayarından (--yk-kart-gecis).
   Ölçülen Flickity değerleri (%90 kayma): 0.025/0.28=0,33sn · 0.014/0.34=0,86 · 0.012/0.36=1,08 · 0.010/0.38=1,41 · 0.008/0.40=1,86.
   Fare hızlı geçerken kareler art arda çakmasın diye konum değişimi 120 ms beklemeli uygulanır. */
(function () {
  var TABLE = [[0.33, 0.025, 0.28], [0.86, 0.014, 0.34], [1.08, 0.012, 0.36], [1.41, 0.010, 0.38], [1.86, 0.008, 0.40]];
  function physics() {
    var s = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--yk-kart-gecis')) || 1.2;
    if (s <= TABLE[0][0]) return TABLE[0].slice(1);
    for (var i = 1; i < TABLE.length; i++) {
      if (s <= TABLE[i][0]) {
        var a = TABLE[i - 1], b = TABLE[i], k = (s - a[0]) / (b[0] - a[0]);
        return [a[1] + (b[1] - a[1]) * k, a[2] + (b[2] - a[2]) * k];
      }
    }
    return TABLE[TABLE.length - 1].slice(1);
  }
  /* Tema init'i öğe görünür alana her girdiğinde yeniden çalıştırıp YENİ Flickity kurabiliyor → kontrol karusel örneği başına. */
  function patch(el, P) {
    if (!el.carousel) return;
    el.removeEventListener('mousemove', P.onMoveHandler);
    if (!el.carousel.__ykSlow) {
      el.carousel.__ykSlow = true;
      var ph = physics();
      el.carousel.options.selectedAttraction = ph[0];
      el.carousel.options.friction = ph[1];
    }
    if (el.__ykMove) return;
    el.__ykMove = true;
    var t;
    el.addEventListener('mousemove', function (e) {
      clearTimeout(t);
      t = setTimeout(function () { if (el.carousel) P.onMoveHandler.call(el, e); }, 120);
    });
    el.addEventListener('mouseleave', function () { clearTimeout(t); });
  }
  /* Tema init'i kurucu içinde bind ediliyor (prototip değişikliği mevcut kartlara işlemez) → fare karta
     girerken (capture, tema dinleyicisinden önce) uygulanır. */
  if (!window.customElements) return;
  customElements.whenDefined('secondary-media').then(function () {
    var P = customElements.get('secondary-media').prototype;
    if (!P || !P.onMoveHandler) return;
    var onEnter = function (e) {
      var el = e.target && e.target.closest ? e.target.closest('secondary-media') : null;
      if (el) patch(el, P);
    };
    document.addEventListener('mouseover', onEnter, true);
    document.addEventListener('mousemove', onEnter, true);
  });
})();
